import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-navside-sponsor',
  templateUrl: './navside-sponsor.component.html',
  styleUrls: ['./navside-sponsor.component.sass']
})
export class NavsideSponsorComponent implements OnInit {
  
  sponsorCol;
  sponsorproductCol;
  items;
  products;
  active: boolean = false;
  constructor(
    private route: Router,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    this.sponsorCol = this.db.getSponsorLists();
    this.sponsorproductCol = this.db.getSponsorProductLists()
  }

  getSponsorProducts(){
    this.products = this.db.getSponsorProductLists()
  }

  routeToBusinessDetailsPage(id){
    this.route.navigateByUrl('/business/'+id)
  }
  routePrivacyPage(){
    this.route.navigateByUrl('/legal/privacy')
  }
  routeTermsPage(){
    this.route.navigateByUrl('/legal/terms')
  }
  routeAdvertisePage(){
    //this.route.navigateByUrl('/sponsore')
  }

}
